$(document).on('click', '.tag-subcollection a',function(e) {
    e.preventDefault();
    e.stopPropagation();
    var selectedValue = $(this).text().trim();
    var checkbox = $('input[name="filter.p.m.custom.top_filters"][value="' + selectedValue + '"]');
    if (checkbox.length) {
        checkbox.trigger('click');
    }
});


function updatePrice(el) {
  var selectedOption = el.find('option:selected').attr('data-price');
  var data_price = el.find('option:selected').attr('data-com-price');
  el.parents('.upsell_btn').find('.add-to-cart span.total_price').text(`- ${selectedOption}`);
  el.parents('.pro_upsell').find('h5.up_price').html(`${selectedOption}<span class="upcompr">${data_price}</span>`);
}

$('select.dp-down-plan').on('change', function () {
  updatePrice($(this));
});

$('select.dp-down-plan').each(function () {
  updatePrice($(this));
});
